<template>
    <div id="med-administration-container">
        <div class="page-height">
            <MdTitle v-bind:Text="$t('MedicationAdministration.Title')" />

            <b-row>
                <b-col sm="12" lg="12" md="12">
                    <div class="textlabel" :data-label="this.$t('Shared.SearchElements')">
                        <div class="input-group" dir="ltr">
                            <input
                                type="text"
                                class="form-control"
                                :dir="dirInput"
                                v-model="parameters.searchCriteria"
                                @keyup.enter="filterHandler"
                            />

                            <div class="input-group-append">
                                <MdButton
                                    v-bind:Name="'btnsearchinput'"
                                    v-bind:VariantProp="'btn btn-sm search-attached'"
                                    v-bind:IconClass="'mdi mdi-magnify'"
                                    v-on:click="filterHandler"
                                >
                                </MdButton>
                            </div>
                        </div>
                    </div>
                </b-col>
            </b-row>

            <b-row>
                <b-col lg="3" md="3" sm="12">
                    <MdDateTime
                        :Label="$t('Nurses.DateTimeFrom')"
                        :Model="parameters.dateFrom"
                        @input="parameters.dateFrom = $event"
                        :Id="'MarsDateTimeFrom'"
                        :Type="'datetime'"
                        :OnPressEnter="filterHandler"
                        :isRequired="false"
                        :isConfirm="false"
                        :ReadOnly="false"
                        :isValid="isDateFromValid"
                    >
                    </MdDateTime>
                </b-col>
                <b-col lg="3" md="3" sm="12">
                    <MdDateTime
                        :Label="$t('Nurses.DateTimeTo')"
                        :Model="parameters.dateTo"
                        @input="parameters.dateTo = $event"
                        :Id="'MarsDateTimeTo'"
                        :Type="'datetime'"
                        :OnPressEnter="filterHandler"
                        :isRequired="false"
                        :isConfirm="false"
                        :ReadOnly="false"
                        :isValid="isDateToValid"
                    >
                    </MdDateTime>
                </b-col>
                <b-col lg="3" md="3" sm="12">
                    <MdSelect
                        v-bind:Label="$tc('Shared.Program')"
                        v-bind:Options="programList"
                        v-bind:Model="programVModel"
                        v-bind:FieldDescription="'name'"
                        v-bind:FieldCode="'code'"
                        v-bind:Multiple="false"
                        v-bind:RequireEvent="true"
                        v-bind:IfUsevalidation="false"
                        :Input="changeDropDownPrograms"
                    />
                </b-col>
                <b-col lg="3" md="3" sm="12">
                    <MdSelect
                        v-bind:Label="$tc('Shared.Patient')"
                        v-bind:Options="patientList"
                        v-bind:Model="patients"
                        v-bind:FieldDescription="'patientname'"
                        v-bind:FieldCode="'patientcode'"
                        v-bind:Multiple="false"
                        :Input="changeDropDownPatients"
                    />
                </b-col>
            </b-row>
            <b-row>
                <b-col lg="3" md="3" sm="12">
                    <MdSelect
                        v-bind:Label="$t('Shared.Building')"
                        v-bind:Options="buildingsList"
                        v-bind:FieldDescription="'description'"
                        v-bind:FieldCode="'code'"
                        v-bind:Model="buildings"
                        v-bind:Multiple="false"
                        :Input="changeDropDownBuilding"
                        v-bind:IsDisabled="!buildingsEnabled"
                    />
                </b-col>
                <b-col lg="3" md="3" sm="12">
                    <MdSelect
                        v-bind:Label="$t('Shared.Level')"
                        v-bind:Options="levelList"
                        v-bind:FieldDescription="'description'"
                        v-bind:FieldCode="'code'"
                        v-bind:Model="level"
                        v-bind:Multiple="false"
                        :Input="changeDropDownLevel"
                    />
                </b-col>
                <b-col lg="3" md="3" sm="12">
                    <MdSelect
                        v-bind:Label="$tc('Shared.Room')"
                        v-bind:Options="roomList"
                        v-bind:FieldDescription="'name'"
                        v-bind:FieldCode="'code'"
                        v-bind:UseResetModel="true"
                        v-bind:Model="room"
                        v-bind:Multiple="false"
                        :Input="changeDropDownRoom"
                    />
                </b-col>
                <b-col lg="3" md="3" sm="12" v-if="nursingUnitsList.length > 0">
                    <MdSelect
                        v-bind:Label="$t('Clinical.NursingUnits')"
                        v-bind:Options="nursingUnitsList"
                        v-bind:Model="nursingUnitsModel"
                        v-bind:Multiple="true"
                        v-bind:FieldDescription="'name'"
                        v-bind:FieldCode="'code'"
                        :Input="changeDropDownNursingUnits"
                    />
                </b-col>
            </b-row>
            <b-row>
                <b-col lg="3" md="3" sm="12">
                    <MdSelect
                        v-bind:Label="$tc('Shared.Mode')"
                        v-bind:Options="medicationAdminModeOptions"
                        v-bind:FieldDescription="'name'"
                        v-bind:FieldCode="'value'"
                        v-bind:Model="mode"
                        v-bind:Multiple="false"
                        :Input="changeDropDownMode"
                    />
                </b-col>
                <b-col lg="3" md="3" sm="12">
                    <MdSelect
                        v-bind:Label="$tc('Shared.Status')"
                        v-bind:Options="medicationAdminStatusOptions"
                        v-bind:FieldDescription="'text'"
                        v-bind:FieldCode="'value'"
                        v-bind:Model="status"
                        v-bind:Multiple="false"
                        :Input="changeDropDownStatus"
                    />
                </b-col>
                <b-col lg="3" md="3" sm="3">
                    <MdRadioGroup
                        v-bind:Label="$t('Shared.Type')"
                        v-model="reportType"
                        v-bind:Options="reportTypeOptions"
                        v-bind:Name="'radio'"
                        v-bind:Stacked="false"
                        v-on:change="changeReportType"
                    />
                </b-col>
                <b-col lg="3" md="3" sm="3">
                    <div class="mt-3 text-right">
                        <button
                            v-on:click="filterHandler"
                            type="button"
                            class="btn btn-primary btn-login mx-2"
                            id="btnsearchinput"
                        >
                            {{ $t('Shared.Search') }}
                        </button>
                    </div>
                </b-col>
            </b-row>

            <MdTitle
                v-bind:Text="$t('Shared.SearchResult')"
                v-bind:isSubtitle="true"
                v-bind:Name="'T_TitleSearch'"
            />

            <b-row>
                <b-col class="col-12 mt-2">
                    <MdTable
                        v-bind:fields="fields"
                        v-bind:items="items"
                        v-bind:totalRows="totalRows"
                        v-bind:showMessageIsEmpty="showMessageIsEmpty"
                        v-bind:currentPage="currentPage"
                        v-bind:perPage="perPage"
                        v-bind:pageOptions="pageOptions"
                        v-bind:VisibleEditIcon="false"
                        v-bind:FieldsDate="fieldsDateArr"
                        v-bind:multiSelect="false"
                        :pageChanged="pageChanged"
                        :perPageFunction="perPageFunction"
                        :ShowDetails="true"
                    >
                        <template #row-details="{ row }">
                            <b-card>
                                <b-row class="card mb-3 w-100">
                                    <MdTablePaginationClient
                                        :fields="subFields"
                                        :items="subItems(row.data)"
                                        v-bind:totalRows="subItems(row.data).length"
                                        v-bind:showMessageIsEmpty="true"
                                        v-bind:perPage="perPage"
                                        v-bind:pageOptions="pageOptions"
                                    >
                                    </MdTablePaginationClient>
                                </b-row>
                                <b-button class="btn-login" size="sm" @click="row.toggleDetails">{{
                                    $t('MdTable.HideDetailsTxt')
                                }}</b-button>
                            </b-card>
                        </template>
                    </MdTable>
                </b-col>
            </b-row>
        </div>

        <div class="space-actions"></div>
        <div class="page-actions">
            <MdButton
                v-bind:Label="$t('Shared.Back')"
                v-bind:ClassProp="'primary btn-login mx-2'"
                v-on:click="goToReportList"
                v-bind:Name="'btn_ReportList'"
            />
            <MdButton
                v-bind:Label="$t('Shared.Report')"
                v-bind:ClassProp="'primary btn-login mx-2'"
                v-on:click="print"
                v-bind:Name="'btn_Print'"
            />
            <b-dropdown
                id="dropdown-dropup"
                dropup
                :text="$t('Shared.Export')"
                variant="primary"
                class="m-2"
            >
                <b-dropdown-item v-on:click="handlePdf('export')">{{
                    $t('Shared.PDF')
                }}</b-dropdown-item>
                <b-dropdown-item v-on:click="handlePdf('email')">{{
                    $t('Shared.PDFByEmail')
                }}</b-dropdown-item>
                <b-dropdown-item v-on:click="handleCSV('export')">{{
                    $t('Shared.CSV')
                }}</b-dropdown-item>
                <b-dropdown-item v-on:click="handleCSV('email')">{{
                    $t('Shared.CSVByEmail')
                }}</b-dropdown-item>
            </b-dropdown>
        </div>

        <DxPopup
            :visible="isReportVisible"
            :drag-enabled="true"
            :close-on-outside-click="false"
            :show-close-button="true"
            :show-title="true"
            :hide-on-parent-scroll="true"
            :title="$t('MedicationAdministration.Title')"
            @hidden="onHiddenReport"
            :resize-enabled="true"
            shading-color="rgba(0, 0, 0, 0.5)"
            height="94vh"
            width="97vw"
            @showing="onShowing"
        >
            <ReportViewer
                ref="report"
                :ReportName="reportName"
                :ReportTitle="$t('MedicationAdministration.Title')"
                :IsAnAPIReport="true"
            />
        </DxPopup>

        <CSVExportHelper
            ref="csvExportHelper"
            v-bind:conformSubject="$t('MedicationAdministration.Title')"
            v-bind:sendEmailAPI="'/Utils/sendEmail'"
            v-bind:exportCsvAPI="'/DailyServiceCharge/exportCSV'"
        >
        </CSVExportHelper>
    </div>
</template>

<script>
import Utils from '@/common/utils';
import DBFunctions from '@/common/DBFunctions.js';
import ShowMessage from '@/components/messages/ShowMessage.js';
import ClinicalService from '@/services/clinical.service';
import NursingUnitsService from '@/services/nursingunits.service';
import AdmissionService from '@/services/admission.service';
import MarsService from '@/services/mars.service';
import PatientService from '@/services/patient.service';
import GlobalService from '@/services/global.service';
import moment from 'moment';
import EnumService from '@/services/enum.service';
import { DxPopup } from 'devextreme-vue/popup';

export default {
    name: 'MedicationAdministration',
    mixins: [ShowMessage, DBFunctions],
    components: { DxPopup },
    data() {
        return {
            parameters: {
                searchCriteria: '',
                dateTo: null,
                dateFrom: null,
                programCodeList: null,
                patientCodeList: null,
                buildingCodeList: null,
                roomCodeList: null,
                levelCodeList: null,
                nursingUnitsList: [],
                modeList: null,
                statusList: null
            },
            dirInput: this.$i18n.locale === 'ar' ? 'rtl' : 'ltr',
            programList: [],
            patientList: [],
            buildingsList: [],
            roomList: [],
            levelList: [],
            nursingUnitsList: [],
            programVModel: [],
            NursingUnitsModel: [],
            patients: '',
            buildings: '',
            level: '',
            room: '',
            mode: null,
            status: null,
            fullParam: {
                PageSize: 0,
                PageNumber: 0
            },
            medicationAdminStatusOptions: EnumService.MedicationAdminStatus,
            medicationAdminModeOptions: EnumService.MedicationAdminTimedPrnMode,
            reportTypeOptions: [
                { value: 'details', text: this.$t('Shared.Details') },
                { value: 'summary', text: this.$t('Shared.Summary') }
            ],
            isDateToValid: true,
            isDateFromValid: true,
            isReportVisible: false,
            reportParams: [],
            showMessageIsEmpty: false,
            totalRows: 0,
            pageOptions: [5, 10, 15],
            currentPage: 1,
            perPage: 10,
            items: [],
            fields: [
                {
                    key: 'show_details',
                    sortable: false,
                    label: this.$t('Shared.ShowDetails'),
                    class: 'text-left'
                },
                {
                    key: 'patientName',
                    sortable: true,
                    label: this.$t('Shared.PatientName'),
                    class: 'text-left'
                },
                {
                    key: 'patientCode',
                    sortable: true,
                    label: this.$t('Shared.PatientCode'),
                    class: 'text-left'
                },
                {
                    key: 'prescriber',
                    sortable: true,
                    label: this.$t('Shared.Prescriber'),
                    class: 'text-left'
                },
                {
                    key: 'issuedDate',
                    sortable: true,
                    label: this.$t('Shared.IssuedDate'),
                    class: 'text-center',
                    formatter: value => {
                        return value ? Utils.formatterDateToString(value) : '';
                    }
                },
                {
                    key: 'drugName',
                    sortable: true,
                    label: this.$t('Shared.DrugName'),
                    class: 'text-left'
                },
                {
                    key: 'quantityUOM',
                    sortable: true,
                    label: this.$t('Shared.quantity'),
                    class: 'text-right'
                },
                {
                    key: 'dispensingUOM',
                    sortable: true,
                    label: this.$t('Shared.Unit'),
                    class: 'text-left'
                }
            ],
            fieldsDateArr: ['issuedDate'],
            reportType: 'details'
        };
    },
    computed: {
        buildingsEnabled() {
            return Utils.isNullOrEmptyString(this.$store.state.restrictions.buildingLocation);
        },
        reportName() {
            if (this.reportType === 'details') {
                return 'MedicationAdministrationDetail';
            }
            return 'MedicationAdministrationSummary';
        },
        subFields() {
            if (this.reportType === 'details') {
                return [
                    {
                        key: 'adminDateTime',
                        sortable: true,
                        label: this.$t('MedicationAdministration.PrescDateTime'),
                        class: 'text-center',
                        formatter: value => {
                            return value ? Utils.formatterDateTimeToString(value) : '';
                        }
                    },
                    {
                        key: 'givenDateTime',
                        sortable: true,
                        label: this.$t('Shared.GivenDateTime'),
                        class: 'text-center',
                        formatter: value => {
                            return value ? Utils.formatterDateTimeToString(value) : '';
                        }
                    },
                    {
                        key: 'sysDate',
                        sortable: true,
                        label: this.$t('MedicationAdministration.SignedDateTime'),
                        class: 'text-center',
                        formatter: value => {
                            return value ? Utils.formatterDateTimeToString(value) : '';
                        }
                    },
                    {
                        key: 'given',
                        sortable: true,
                        label: this.$t('modalMarsMed.Given'),
                        class: 'text-left'
                    },
                    {
                        key: 'qtySet',
                        sortable: true,
                        label: this.$t('MedicationAdministration.QTYPresc'),
                        class: 'text-right'
                    },
                    {
                        key: 'givenQTY',
                        sortable: true,
                        label: this.$t('MedicationAdministration.QTYGiven'),
                        class: 'text-right'
                    },
                    {
                        key: 'dispensingUOM',
                        sortable: true,
                        label: this.$t('Shared.Unit'),
                        class: 'text-left'
                    },
                    {
                        key: 'notes',
                        sortable: true,
                        label: this.$t('MedicationAdministration.Notes'),
                        class: 'text-left'
                    },
                    {
                        key: 'employeeName',
                        sortable: true,
                        label: this.$tc('Shared.Employee', 1),
                        class: 'text-left'
                    }
                ];
            }

            return [
                {
                    key: 'minAdminDate',
                    sortable: true,
                    label: this.$t('MedicationAdministration.MinAdminDate'),
                    class: 'text-center',
                    formatter: value => {
                        return value ? Utils.formatterDateToString(value) : '';
                    }
                },
                {
                    key: 'maxAdminDate',
                    sortable: true,
                    label: this.$t('MedicationAdministration.MaxAdminDate'),
                    class: 'text-center',
                    formatter: value => {
                        return value ? Utils.formatterDateToString(value) : '';
                    }
                },
                {
                    key: 'sumQTYSet',
                    sortable: true,
                    label: this.$t('MedicationAdministration.QTYPresc'),
                    class: 'text-right'
                },
                {
                    key: 'sumGivenQTY',
                    sortable: true,
                    label: this.$t('MedicationAdministration.QTYGiven'),
                    class: 'text-right'
                },
                {
                    key: 'dispensingUOM',
                    sortable: true,
                    label: this.$t('Shared.Unit'),
                    class: 'text-left'
                }
            ];
        }
    },
    methods: {
        goToReportList() {
            this.checkExistFavorite('/app/reports/nurses');
            this.$router.push({ name: 'reportListNurses' }).catch(() => {});
        },

        changeReportType() {
            this.$nextTick(() => this.filterHandler());
        },

        changeDropDownPrograms(item) {
            this.parameters.programCodeList = item ? [item.code] : null;
            this.filterHandler();
        },

        changeDropDownPatients(item) {
            this.parameters.patientCodeList = item ? [item.patientcode] : null;
            this.filterHandler();
        },

        changeDropDownRoom(item) {
            this.parameters.roomCodeList = item ? [item.code] : null;
            this.filterHandler();
        },

        async changeDropDownLevel(item) {
            this.parameters.levelCodeList = item ? [item.code] : null;
            this.filterHandler();
        },

        async changeDropDownBuilding(item) {
            this.parameters.buildingCodeList = item ? [item.code] : null;
            await this.getRomms({ BuildingCodeList: this.parameters.buildingCodeList });

            this.parameters.roomCodeList = this.room ? [this.room.code] : null;
            this.filterHandler();
        },

        changeDropDownNursingUnits(items) {
            this.parameters.nursingUnitsList = items ? items.map(element => element.code) : [];
            this.nursingUnitsModel = items;

            this.filterHandler();
        },

        changeDropDownMode(item) {
            this.parameters.modeList = item ? item.value : null;
            this.filterHandler();
        },

        changeDropDownStatus(item) {
            this.parameters.statusList = item ? item.value : null;
            this.filterHandler();
        },

        pageChanged(page) {
            this.currentPage = page;
            this.listingAsync();
        },

        perPageFunction(perPage) {
            this.perPage = perPage;
            this.currentPage = 1;
            this.listingAsync();
        },

        subItems(item) {
            if (this.reportType === 'details') {
                return item.details || [];
            }
            return item.summary ? [item.summary] : [];
        },

        validate_required() {
            this.isDateToValid = true;
            this.isDateFromValid = true;

            if (
                !Utils.isNullOrEmptyString(this.parameters.dateFrom) &&
                !Utils.isNullOrEmptyString(this.parameters.dateTo)
            ) {
                const result = Utils.validateDateRange(
                    this.parameters.dateFrom,
                    this.parameters.dateTo
                );

                this.$forceUpdate();

                if (!result.valid) {
                    this.isDateToValid = result.valid && !result.fields.includes('toDate');
                    this.isDateFromValid = result.valid && !result.fields.includes('fromDate');

                    this.showMessage(this.$tc('Msg.Error'), this.$t(result.message), 'error');
                }

                return result.valid;
            }

            return true;
        },

        handlePdf(action) {
            if (!this.validate_required()) {
                return;
            }

            this.initializePdfParameters();
            switch (action) {
                case 'export':
                    this.$refs.csvExportHelper.exportToPdf(
                        this.reportName,
                        true,
                        false,
                        this.reportParams
                    );
                    break;
                case 'email':
                    this.$refs.csvExportHelper.emailPdf(
                        this.reportName,
                        true,
                        false,
                        this.reportParams
                    );
                    break;
                default:
                    console.warn('unknow action:', action);
                    break;
            }
        },

        handleCSV(action) {
            if (!this.validate_required()) {
                return;
            }

            switch (action) {
                case 'export':
                    this.$refs.csvExportHelper.exportCSV(this.parameters);
                    break;
                case 'email':
                    this.$refs.csvExportHelper.emailCSV(this.parameters);
                    break;
                default:
                    console.warn('unknow action:', action);
                    break;
            }
        },

        print() {
            if (this.validate_required()) {
                this.onClickShowReport();
            }
        },

        onClickShowReport() {
            this.initializePdfParameters();
            this.isReportVisible = true;
            this.$refs.report.buildDocument(this.reportParams);
        },

        initializePdfParameters() {
            this.reportParams = [];
            Object.keys(this.parameters).forEach(propertyName => {
                const entity = this.parameters[propertyName];

                if (entity) {
                    if (Array.isArray(entity)) {
                        entity.forEach(element =>
                            this.reportParams.push({ paramName: propertyName, paramValue: element })
                        );
                    } else {
                        this.reportParams.push({ paramName: propertyName, paramValue: entity });
                    }
                }
            });
        },

        onHiddenReport() {
            this.isReportVisible = false;
        },

        onShowing(e) {
            let contentElement = e.component.content();
            let titleElement = e.component._$title[0];
            contentElement.style.padding = '0px';
            titleElement.style.padding = '0px 20px';
        },

        filterHandler() {
            this.currentPage = 1;
            this.listingAsync();
        },

        apiCallback(parameters) {
            if (this.reportType === 'details') {
                return MarsService.getAdministrationDetailsListing(parameters);
            }

            return MarsService.getAdministrationListing(parameters);
        },

        async listingAsync() {
            if (this.validate_required()) {
                const parameters = {
                    PageSize: this.perPage,
                    PageNumber: this.currentPage,
                    ...this.parameters
                };

                await this.apiCallback(parameters)
                    .then(response => {
                        if (response.status == '200' && response.data) {
                            this.items = response.data;
                            this.showMessageIsEmpty = response.data.length === 0;
                            let headerString = response.headers['x-pagination'];
                            const header = JSON.parse(headerString);
                            this.totalRows = header.TotalCount;
                        }
                    })
                    .catch(error => {
                        this.showResponseErrorMessage(error);
                    });
            }
        },

        async getPrograms() {
            const parameter = {
                programsRestriction: this.$store.state.restrictions.programs
            };
            await ClinicalService.getPrograms(parameter)
                .then(response => {
                    if (response.status == '200' && response.data && response.data.length > 0) {
                        this.programList = response.data;
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        async getNursingUnits() {
            await NursingUnitsService.getAll()
                .then(response => {
                    if (response.status == '200') {
                        this.nursingUnitsList = response.data;
                    }
                })
                .catch(error => {
                    if (error.response) {
                        this.showMessage(this.$tc('Msg.Error'), error, 'error');
                    }
                });
        },

        async getBuildings() {
            await AdmissionService.getBuildings({
                Code: this.$store.state.restrictions.buildingLocation
            })
                .then(response => {
                    if (response.status == '200') {
                        this.buildingsList = response.data;

                        if (!this.buildingsEnabled) {
                            this.buildings = this.$store.state.restrictions.buildingLocation;
                            this.parameters.buildingCodeList.push(this.buildings);
                        }
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        async getLevel() {
            let param = {
                CodeType: 'RoomLevel',
                OrderBy: 'SeqNo'
            };
            await GlobalService.getGlobalCustom(param)
                .then(response => {
                    if (response.status == '200' && response.data.length > 0) {
                        this.levelList = response.data;
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        async getRomms(build) {
            await MarsService.getMarsRooms(build)
                .then(response => {
                    if (response.status == '200' && response.data.length > 0) {
                        this.roomList = response.data;
                        if (this.roomList.length === 1) {
                            this.room = this.roomList[0].code;
                        } else {
                            this.room = '';
                        }
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        async getPatients() {
            await PatientService.getAll(this.fullParam)
                .then(response => {
                    if (response.status == '200' && response.data) {
                        this.patientList = response.data;
                        this.patientList.forEach(function(element) {
                            element.patientname =
                                element.firstname +
                                ' ' +
                                element.lastname +
                                ' - ' +
                                element.patientcode;
                        });
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        async getDateTime() {
            await GlobalService.getDateTime()
                .then(response => {
                    if (response.data) {
                        this.parameters.dateFrom = Utils.formatterToISO2(
                            moment(response.data)
                                .subtract(1, 'hours')
                                .subtract(moment(response.data).minute(), 'minutes')
                        );
                        this.parameters.dateTo = Utils.formatterToISO2(
                            moment(response.data)
                                .add(1, 'hours')
                                .subtract(moment(response.data).minute(), 'minutes')
                        );
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        }
    },

    mounted() {
        Promise.allSettled([
            this.getDateTime(),
            this.getPrograms(),
            this.getNursingUnits(),
            this.getBuildings(),
            this.getLevel(),
            this.getRomms({ BuildingCodeList: [] }),
            this.getPatients()
        ]).then(result => (result.length === 7 ? this.listingAsync() : null));
    }
};
</script>
